import { useEffect } from 'react';
import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import { useNavigate } from "react-router-dom"
import {
  useSearchParams,
} from "react-router-dom"
import {currentUserActions} from '../reducers/currentUser'
import {validatePassword, validateFieldReq} from '../utils/validation'
import LoginHeader from "../components/LoginHeader"
import {ShowPassword, HidePassword} from '../components/Icons'
import PasswordInput from './PasswordInput';
import LogoHeader from "../components/LogoHeader";
import CustomButton from './CustomButton';

const LoginResetPasswordConfirm = ({view} : {view: 'company' | 'talent'}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  const currentUser = useSelector((state: any) => state.currentUser)
  const {showPassword, error, errors, isLoading} = currentUser
  const [queryParameters] = useSearchParams()
  const reset_password_code = queryParameters.get("reset_password_code")

  const switchShowPassword = () => {
    dispatch(currentUserActions.switchShowPassword())
  }
  const resetPasswordConfirm = (event: any) => {
    event.preventDefault()

    if (isLoading) return
    const formData = new FormData(event.target);
    const password = formData.get('password')
    const password_confirmation = formData.get('password_confirmation')

    let errors = {} as any
    const validatePasswordRes = validatePassword(password)
    if (validatePasswordRes != true)
      errors['password'] = validatePasswordRes
    const validatePasswordConfirmRes = validateFieldReq(password_confirmation, 'パスワード確認用')
    if (validatePasswordConfirmRes != true)
      errors['password_confirmation'] = validatePasswordConfirmRes

    dispatch(currentUserActions.setError(null))
    dispatch(currentUserActions.setErrors(errors))
    if (Object.keys(errors).length != 0) return
    
    if (password != password_confirmation) {
      dispatch(currentUserActions.setError("同じ値をもう一度入力してください。"))
      return
    }

    dispatch(currentUserActions.resetPasswordConfirm({navigate, view, reset_password_code, password}))
  }

  return (
    <div className='static md:fixed md:inset-0 bg-alu-base'>
      <div className='min-w-[24.75rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
        <LogoHeader view={view} page="advanced"></LogoHeader>
        <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[21.4378rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6'>
          <LoginHeader title="パスワード再設定"></LoginHeader>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
            <form onSubmit={resetPasswordConfirm} className="bg-white w-full">
              <div className="mb-4">
                <label className="block mb-2 text-sm pointer-events-none" htmlFor="password">
                  パスワード
                </label>
                <div className='relative'>
                  <PasswordInput
                    error={(errors['password']|| "").length > 0}
                    errorText={errors['password']}
                    id="password"
                    name="password"
                    placeholder="入力してください"
                  />
                </div>
              </div>
              <div className="mb-10">
                <label className="block mb-2 text-sm pointer-events-none" htmlFor="password_confirmation">
                パスワード確認用
                </label>
                <div className='relative'>
                  <PasswordInput
                    error={(errors['password_confirmation']|| "").length > 0 || error}
                    errorText={errors['password_confirmation'] || error}
                    id="password_confirmation"
                    name="password_confirmation"
                    placeholder="入力してください"
                  />
                </div>
              </div>

              <CustomButton type="submit" disabled={isLoading} width='full'>
                {view == 'talent' ? "完了" : "ログイン"}
              </CustomButton>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginResetPasswordConfirm;
